import { BadCredentialsError } from './bad-credentials-error'

class ToolsApi {
  constructor(url) {
    this.setUrl(url)
  }

  setUrl = (url) => {
    const normalized = (url || '').trim().replace(/\/+$/, '')
    this.url = normalized
  }

  credentials = (username, password) => {
    this.username = username
    this.password = password
  }

  _authHeader = () => {
    if (!this.username || !this.password) {
      throw new BadCredentialsError('Missing credentials')
    }
    return 'Basic ' + btoa(this.username + ':' + this.password)
  }

  _request = async (path, { method = 'GET', headers = {}, body } = {}) => {
    const authHeader = this._authHeader()
    let response
    try {
      response = await fetch(`${this.url}${path}`, {
        method,
        headers: {
          Accept: 'application/json',
          Authorization: authHeader,
          ...headers,
        },
        body
      })
    } catch (error) {
      throw new Error(`Network error (CORS/URL/Timeout) calling ${method} ${path}: ${error?.message || error}`)
    }

    if (response.status === 401) {
      throw new BadCredentialsError('Invalid credentials')
    }

    if (!response.ok) {
      let details = ''
      try {
        details = await response.text()
      } catch {
        details = ''
      }
      const suffix = details ? ` - ${details.slice(0, 500)}` : ''
      throw new Error(`Request failed (${response.status} ${response.statusText}) for ${method} ${path}${suffix}`)
    }

    return response
  }

  loadTools = async () => {
    const response = await this._request('/admin/tools/')
    return await response.json()
  }

  saveTool = async (tool) => {
    const method = tool.id ? 'PUT' : 'POST'
    const path = tool.id ? `/admin/tools/${tool.id}` : '/admin/tools/'
    const response = await this._request(path, {
      method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(tool)
    })

    return response
  }

  deleteTool = async (tool) => {
    const response = await this._request(`/admin/tools/${tool.id}`, { method: 'DELETE' })
    return response
  }
}

export default ToolsApi
